var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequirementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0618 12.1313C25.0618 18.8313 19.6304 24.2627 12.9305 24.2627C6.23052 24.2627 0.799133 18.8313 0.799133 12.1313C0.799133 5.43139 6.23052 0 12.9305 0C19.6304 0 25.0618 5.43139 25.0618 12.1313ZM4.35515 10.5397C4.97852 9.9941 5.92617 10.0571 6.4718 10.6805L10.5812 15.3754L18.0912 7.04598C18.646 6.43071 19.5945 6.38165 20.2097 6.93639C20.825 7.49113 20.8741 8.43961 20.3193 9.05488L11.8223 18.4789C11.4651 18.8752 10.9445 19.0366 10.4548 18.9531C10.0216 18.9667 9.58599 18.7933 9.27826 18.4418L4.21439 12.6564C3.66876 12.033 3.73179 11.0854 4.35515 10.5397Z",
    fill: "#CE838E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequirementIcon);
export default __webpack_public_path__ + "static/media/RequirementIcon.a79a2ffb09b89f12cd7238e2fcff4d31.svg";
export { ForwardRef as ReactComponent };